/**
 * authoredImpact — the ability's own impact for a server-confirmed hit
 * (plan 29 F9, lane BX 2026-10-11).
 *
 * A confirmed hit the client never played optimistically (an area tick, a
 * zone, a channel spin) used to draw the generic school splash
 * (`hit_holy`, `hit_spark`…) from CombatFeedbackManager.triggerImpact, so
 * every holy area hit — Divine Storm, Consecration — showed the same yellow
 * disc and star whatever its TOML said. When the ability's TOML
 * `impact_effect` names an authored one-shot burst (a statically registered
 * def, not a generated stand-in, not a school hit, not a zone), that def is
 * the impact instead; the tier still owns the shake, freeze and flash.
 */
import { DEFAULT_VFX_EFFECTS } from './config/VFXEffectDefs';
import { ABILITY_VFX_EFFECTS } from './config/VFXAbilityDefs';
import { getAbilityData } from '../../shared/content/AbilityDataAdapter';

let bursts: Set<string> | null = null;
function authoredBursts(): Set<string> {
  bursts ??= new Set([...DEFAULT_VFX_EFFECTS, ...ABILITY_VFX_EFFECTS]
    .filter((d) => d.category === 'burst' && !d.id.startsWith('hit_'))
    .map((d) => d.id));
  return bursts;
}

/** The authored burst a confirmed hit of `abilityId` plays, if its TOML names one. */
export function authoredImpactBurstId(abilityId: string | null | undefined): string | undefined {
  if (!abilityId) return undefined;
  const id = (getAbilityData(abilityId) as { vfx?: { impactEffect?: string } } | undefined)?.vfx?.impactEffect;
  return id && authoredBursts().has(id) ? id : undefined;
}
